import { Button } from "..";
import { cn } from "@utils";

export function GridSection({ className, children }) {
  return (
    <div
      className={cn(
        "w-100 p-5 grid grid-cols-2 gap-6 border-b border-zinc-200 shrink-0",
        className
      )}
    >
      {children}
    </div>
  );
}

export function GridSectionItem({ children }) {
  return <div className="">{children}</div>;
}

export function GridSectionHeader({ children }) {
  return <div className="text-sm text-zinc-500 mb-1">{children}</div>;
}

export function GridSectionBody({ children }) {
  return <div className="text-sm font-medium">{children}</div>;
}

export function GridSectionSpan({ children }) {
  return <div className="col-span-2 flex items-center">{children}</div>;
}

export function GridSectionAction({ onClick, color, children }) {
  return (
    <Button className="col-span-2" onClick={onClick} color={color}>
      {children}
    </Button>
  );
}
